import { render } from "./BaseHero.vue?vue&type=template&id=76854ac6"
import script from "./BaseHero.vue?vue&type=script&lang=js"
export * from "./BaseHero.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__